// =============================================================================
// features/sales/campaigns/components/CampaignStatusBadge.tsx — Badge
// canônico do ciclo de vida de campanha (doc 26 §7 — componente nomeado
// `CampaignStatusBadge`). Exportado para reuso em F35-S09 (detalhe) e
// F35-S10 (operação) — contrato de saída deste slot.
//
// Badge (DS §9.5) já combina dot colorido + texto — status nunca depende só
// de cor (F35-S07 DoD).
// =============================================================================

import type { CampaignStatus } from '@elemento/shared-schemas';
import * as React from 'react';

import { Badge } from '../../../../components/ui/Badge';
import type { BadgeVariant } from '../../../../components/ui/Badge';

const STATUS_LABEL: Record<CampaignStatus, string> = {
  draft: 'Rascunho',
  ready: 'Pronta',
  active: 'Ativa',
  paused: 'Pausada',
  completed: 'Concluída',
  cancelled: 'Cancelada',
};

const STATUS_VARIANT: Record<CampaignStatus, BadgeVariant> = {
  draft: 'neutral',
  ready: 'info',
  active: 'success',
  paused: 'warning',
  completed: 'neutral',
  cancelled: 'danger',
};

export interface CampaignStatusBadgeProps {
  status: CampaignStatus;
  className?: string;
}

export function CampaignStatusBadge({
  status,
  className,
}: CampaignStatusBadgeProps): React.JSX.Element {
  return (
    <Badge variant={STATUS_VARIANT[status]} {...(className ? { className } : {})}>
      {STATUS_LABEL[status]}
    </Badge>
  );
}
